// extracted by mini-css-extract-plugin
export default {"bookmark":"Bookmark_bookmark__9WFJ3"};